import React from 'react';
import { BaseChart } from './BaseChart';
import { useTheme } from '@mui/material';

export interface DonutChartProps {
  title?: string;
  seriesName: string;
  data: Array<{ name: string; value: number }>;
  height?: number | string;
}

export const DonutChart: React.FC<DonutChartProps> = ({
  title,
  seriesName,
  data,
  height = 300,
}) => {
  const theme = useTheme();

  const option = {
    title: title ? { text: title, left: 'center' } : undefined,
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
    },
    legend: {
      orient: 'horizontal',
      left: 'center',
      bottom: 0,
    },
    series: [
      {
        name: seriesName,
        type: 'pie',
        radius: ['45%', '70%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderRadius: 8,
          borderColor: theme.palette.background.paper,
          borderWidth: 2,
        },
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontWeight: 'bold',
            color: theme.palette.text.primary,
          },
        },
        labelLine: {
          show: false,
        },
        data: data,
      },
    ],
  };

  return <BaseChart option={option} height={height} />;
};
